import {Configuration, ImageApi, MenuApi, OrderApi} from "@sobr/wine-menu-client";
import {createFsCockpitAuthedAxiosInstance} from "./axiosFsCockpitAuthAdapter";

const WINE_MENU_API_BASE_URL = process.env.REACT_APP_WINE_MENU_BACKEND_BASE_URL;
const REACT_APP_NEW_TEST_ENV = process.env.REACT_APP_NEW_TEST_ENV;
console.log(REACT_APP_NEW_TEST_ENV);

const fsCockpitAuthedAxiosInstance = createFsCockpitAuthedAxiosInstance();

export const menuApi = new MenuApi(new Configuration({}), WINE_MENU_API_BASE_URL, fsCockpitAuthedAxiosInstance);
export const orderApi = new OrderApi(new Configuration({}), WINE_MENU_API_BASE_URL, fsCockpitAuthedAxiosInstance);
export const imageApi = new ImageApi(new Configuration({}), WINE_MENU_API_BASE_URL, fsCockpitAuthedAxiosInstance);